import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { Scrollable } from '../../../shared/scrollable/Scrollable';
import { Toggle } from '../../../shared/toggle';
import { getAllDocumentNames } from '../../documents/store';
import styles from '../Clients.module.scss';
import { Client, ClientOpinion, updateClientDetails } from '../store';

const { white, lightestGrey } = styles;

interface ClientDocumentsProps {
    clientDatasetIds: number[];
}

export const ClientDocuments: React.FC<ClientDocumentsProps> = ({ clientDatasetIds }) => {
    const dispatch = useAppDispatch();
    const updateClientProperties = useCallback((key: keyof Client, value: string | number[] | ClientOpinion[] | number | null) => dispatch(updateClientDetails(key, value)), [dispatch]);
    const allDocumentNames = useAppSelector(getAllDocumentNames);
    const datasetOptions = useMemo(() => allDocumentNames.filter(({ datasetId }) => datasetId), [allDocumentNames]);

    const updateDatasetIds = (checked: boolean, datasetId: number) => {
        const datasetIds = checked ? [...clientDatasetIds, datasetId] : clientDatasetIds.filter(id => id !== datasetId);
        updateClientProperties('clientDatasetIds', datasetIds);
    };

    const totalDocuments = useMemo(() => datasetOptions.filter(({ datasetId }) => datasetId && clientDatasetIds.includes(datasetId)).length.toString(), [datasetOptions, clientDatasetIds]);
    const datasetOptionHeaders = [{ name: 'Document' }, { name: 'Visible' }];

    return (
        <div className={styles.clientModalContentWrapper}>
            <div className={styles.clientModalHeader}>
                <div className={styles.clientModalTitle}>Documents Available to Client ({totalDocuments})</div>
            </div>
            <>
                <div className={styles.tableHeader}>
                    {datasetOptionHeaders.map(({ name }) => (
                        <div key={name}>{name}</div>
                    ))}
                </div>
                <div className={styles.tableWrapper}>
                    <Scrollable height='calc(100% - 4px)'>
                        {datasetOptions.map(({ datasetId, documentName }, index) => (
                            <div className={styles.tableRow} key={index} style={{ backgroundColor: index % 2 ? lightestGrey : white }}>
                                <div className={styles.titleCell}>{documentName}</div>
                                <Toggle
                                    checked={clientDatasetIds.includes(datasetId!)}
                                    onChange={checked => updateDatasetIds(checked, datasetId!)}
                                />
                            </div>
                        ))}
                    </Scrollable>
                </div>
            </>
        </div>
    );
};
